
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#FF4F72","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M8.13 6.86v1.16h3.125l2.93 2.022 3.683-1.984.214-.054H21L14.252 15.5H3.968V6.98H2v-.86h2.852v1.9h2.393V6.86H5.88V6h3.616v.86H8.13zM4.851 8.88v5.76h9l5.199-5.776h-.855l-4.068 2.193-3.155-2.176h-6.12zm11.895 6.164a7.695 7.695 0 00-.477.785c-.204.393-.312.722-.312.952 0 .757.581 1.359 1.285 1.359.702 0 1.282-.602 1.282-1.36h.442-.442c0-.229-.108-.559-.311-.951a7.696 7.696 0 00-.477-.785 12.21 12.21 0 00-.495-.67c-.17.214-.337.44-.495.67zm2.22 1.737h.442C19.41 18 18.446 19 17.243 19c-1.205 0-2.169-.999-2.169-2.22 0-.39.146-.837.407-1.339.146-.28.325-.573.53-.873a13.24 13.24 0 01.897-1.162l.335-.379.335.38a13.238 13.238 0 01.895 1.161c.205.3.384.593.53.873.26.502.406.948.406 1.34h-.442z"}}),_c('path',{attrs:{"d":"M18.848 8.485a3.636 3.636 0 110-7.273 3.636 3.636 0 010 7.273zm.03-6.06a.455.455 0 00-.454.454V5a.455.455 0 00.91 0V2.879a.455.455 0 00-.455-.455zm-.03 4.666a.515.515 0 100-1.03.515.515 0 000 1.03z"}})])])
          )
        }
      }
    